// extracted by mini-css-extract-plugin
export var statItem = "_hc-1";
export var statsRow = "_hc-0";